export default __webpack_public_path__ + "static/media/logo.2e971e83.jpg";